import React, { Component } from 'react'
//import './InvoiceOverview.scss';
import axios from 'axios';
import { ROOT_API_URL } from '../../../../../api-config';
import { auth } from '../../../../../services/auth.service';

import { getInvoices } from '../../../../../Redux/Actions/EndUser/AccountDetailsActions';
import { provideIntlService } from '@progress/kendo-react-intl';
import Modal from 'react-modal';
import ReceiptPDF from '../../../../Shared/ReceiptPDF';
import CircularProgress from '@material-ui/core/CircularProgress';

export class UserPurchaseHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isPopupVisible: false,
            selectedTransactionId: 0,
            transactions: []
        }
    }
    componentDidMount() {
        var url = `${ROOT_API_URL}/stripepayment/GetInvoicesByUser?userId=${this.props.dataItem.PortalUserID}`;
        const options = { method: 'POST', headers: auth.authHeader() };
        axios.get(url, options).then((res) => {
            this.setState({
                transactions: res.data
            })
        });
    }

    cancel = () => {
        this.setState({ isPopupVisible: false })
    };

    render() {

        const organizationsDisplay = this.state.transactions.length > 0 ? (this.state.transactions.map((item, i) => {
            return (
                <li className="list-group-item list-group-item-paragraph receiptItem" key={i}>
                    {/* <p>Transaction ID: <span className="dashboard-info-text">{item.transactionId}</span></p> */}
                    <div className="row">
                        <div className="col-md-4">
                            <p><span className="minWidth">Transaction Name:</span> <span className="dashboard-info-text">{item.name}</span></p>
                        </div>
                        <div className="col-md-2">
                            <p><span className="minWidth">Amount Paid:</span> <span className="dashboard-info-text">${item.grandTotal.toFixed(2)}</span></p>
                        </div>
                        <div className="col-md-3">
                            <p><span className="minWidth">Date:</span> <span className="dashboard-info-text">{provideIntlService(this).formatDate(new Date(item.createDate), 'MM/d/y')}</span></p>
                        </div>
                        <div className="col-md-3 verthorCenter">
                            <button type="button" onClick={() => this.setState({
                                isPopupVisible: true,
                                selectedTransactionId: item.transactionId
                            })} className="btnLink btn btn-sm btnPrimary">VIEW RECEIPT</button>
                        </div>
                    </div>
                </li>
            );
        })) : (<p>There is no purchase history for this User.</p >);
        

        return (
            <div className="my-organization background-white">
                <h1 className="pt-3 pb-3">Purchase History</h1>
                <div className="card mb-2">
                    {this.props.loadingInvoices ?
                        <ul className="card m-2" style={{ verticalAlign: "middle", alignItems: 'center' }}>
                            <CircularProgress style={{ display: 'block', margin: 'auto' }} /> <label>Loading...</label>
                        </ul>

                        :
                        <ul className="list-group list-group-flush dashboard-info-list">{organizationsDisplay}</ul>
                    }
                </div>

                <div className="receipt">
                    <Modal
                        isOpen={this.state.isPopupVisible}
                        onRequestClose={this.cancel}
                        ariaHideApp={false}
                        style={{
                            content: {
                                top: '50%',
                                left: '50%',
                                right: 'auto',
                                bottom: 'auto',
                                marginRight: '-50%',
                                minWidth: '50vw',
                                maxWidth: '50vw',
                                minHeight: '80vh',
                                maxHeight: '80vh',
                                overflow: 'auto',
                                transform: 'translate(-50%, -50%)',
                                borderRadius: '5px'
                            }
                        }}
                    >
                        <ReceiptPDF
                            pdfData={this.state.selectedTransactionId}
                            cancel={this.cancel}
                        />
                    </Modal>
                </div>
			</div>
        )
    }
}

export default UserPurchaseHistory;